<template>
    <div class="fw-jdgl">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <van-tabs>
            <van-tab title="金豆待审核">
                <Jddsh/>
            </van-tab>
            <van-tab title="金豆审核记录">
                <Jdsh/>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import {getCookie,} from "../../../utils/auth";
    import Jddsh from "./jddsh";
    import Jdsh from "./jdsh";

    export default {
        components: {Jddsh,Jdsh},
        data() {
            return {
                title: '金豆管理',
                fwUser: {},
                deptId: '',
                token: '',
                isCk: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-jdgl {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
        padding-top: 46px;
        background-color: #FAFAFA;
    }

</style>